// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"c6b69a22","225":"e84609e6","5122":"1f3a2121","5780":"3794d97c","5912":"aec78970"}[chunkId] + ".css";
};